import { Button as BricksButton } from "@red-digital/bricks";
import classNames from "classnames";
import styles from "./index.module.css";
import PropTypes from "prop-types";

/**
 *
 * @param {mode} defaults to 'dark', 'light' or 'dark', currently only changes the 'outlined' variant
 *
 * f-filled-button (default)
 * f-outlined-button (variant="outlined")
 * f-plain-button (variant="plain")
 * @returns
 */
const Button = ({ children, className, variant, ...props }) => (
  <BricksButton
    v2
    variant={variant}
    className={classNames(styles.btn, className)}
    {...props}
  >
    {children}
  </BricksButton>
);
Button.propTypes = {
  enablenetflixrtb: PropTypes.string,
};
export default Button;
